import { axiosInstance } from "@/utils/lib/axios";
import { QueryFunctionContext, useQuery } from "@tanstack/react-query";

export interface Project {
  ProjectID: string;
  ProjectDescription: string;
  FdtID?: string;
  ClusterID?: string;
}

type ProjectsByFDTIDQueryKey = {
  FdtID: string;
};
async function getProjectsByFDTID(
  queryFunctionContext: QueryFunctionContext,
): Promise<Project[]> {
  const { queryKey } = queryFunctionContext;
  const [_, projectByFDTIDQueryKey] = queryKey;
  const { FdtID } = projectByFDTIDQueryKey as ProjectsByFDTIDQueryKey;

  const response = await axiosInstance.post(
    "/api/project-monitoring/project/getProjectByFDTID",
    {
      FdtID,
    },
  );
  return response.data?.data?.original?.Data;
}
function useProjectByFDTID(projectsByFDTIDQueryKey: ProjectsByFDTIDQueryKey) {
  return useQuery({
    queryKey: ["projectByFDTID", projectsByFDTIDQueryKey],
    queryFn: getProjectsByFDTID,
  });
}

type ProjectsByClusterIDQueryKey = {
  ClusterID: string;
};
async function getProjectsByClusterID(
  queryFunctionContext: QueryFunctionContext,
): Promise<Project[]> {
  const { queryKey } = queryFunctionContext;
  const [_, projectByClusterIDQueryKey] = queryKey;
  const { ClusterID } = projectByClusterIDQueryKey as ProjectsByClusterIDQueryKey;

  const response = await axiosInstance.post(
    "/api/project-monitoring/project/getProjectByCLUSTERID",
    {
      ClusterID,
    },
  );
  return response.data?.data?.original?.Data;
}
function useProjectByCLUSTERID(projectsByClusterIDQueryKey: ProjectsByClusterIDQueryKey) {
  return useQuery({
    queryKey: ["projectByClusterID", projectsByClusterIDQueryKey],
    queryFn: getProjectsByClusterID,
  });
}

export { useProjectByFDTID, useProjectByCLUSTERID };
